import initialState from './initialState'
import {FETCH_SETTINGS, RECEIVE_SETTINGS} from '../actions/actionTypes'

export default function settings(state = initialState.settings, action) {
	let newState
	switch (action.type) {
	case FETCH_SETTINGS:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_SETTINGS:
		newState = action.settings
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/settings.js